import { IProjectEstimateVariable } from '../../interfaces/iproject-estimate-variable';
import { ProjectType } from '../project-type';

export class ProjectEstimateVariableBase {
  ProjectEstimateVariableId: number;
  ProjectTypeId: number;
  VariableName: string;
  VariableValueSql: string;
  LastUpdatedDate: Date;
  LastUpdatedUser: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ProjectType?: ProjectType;

  constructor(item?: IProjectEstimateVariable) {
    if (item) {

      this.ProjectEstimateVariableId = item.ProjectEstimateVariableId;
      this.ProjectTypeId = item.ProjectTypeId;
      this.VariableName = item.VariableName;
      this.VariableValueSql = item.VariableValueSql;
      this.LastUpdatedDate = item.LastUpdatedDate ? new Date(item.LastUpdatedDate) : null;
      this.LastUpdatedUser = item.LastUpdatedUser;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ProjectType = new ProjectType(item.ProjectType);
    }
  }
}